import { useIntegrationMetadataContext } from 'modules/mobileApps/context/integrationMetadata';
import { ModalType, useModalContext } from 'modules/mobileApps/context/modal';
import { useDispatch } from 'react-redux';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { deleteMobileApp } from '../../actions';
import { getIsModalOpen } from './utils';

export const DeleteAppModal = () => {
  const dispatch = useDispatch();
  const { appDetails } = useIntegrationMetadataContext();
  const { closeModal, openedModals } = useModalContext();

  const handleClose = () => {
    closeModal(ModalType.DeleteAppModal);
  };

  const handleDelete = () => {
    dispatch(deleteMobileApp(appDetails));
    handleClose();
  };

  return (
    <Modal
      data-test="mobileApps-deleteAppModal"
      id="delete-app-modal"
      isModalOpen={getIsModalOpen(openedModals, ModalType.DeleteAppModal)}
      onClose={handleClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Delete app?</ModalHeader>
      <ModalBody>
        Are you sure you would like to delete <strong>{appDetails?.name || 'this app'}</strong>?
        This cannot be undone.
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          onClick={handleDelete}
          data-test="mobileApps-DeleteAppModalDeleteButton"
          size={BUTTON_SIZES.LARGE}
        >
          Delete app
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
